define('TescoMobile_Checkout/js/form/element/previous-address-postcode',['Magento_Ui/js/form/element/post-code'], function (Component) {
  'use strict';

  return Component.extend({
    defaults: {
      required: false
    },
    update: function () {
      this.validation['required-entry'] = false;
      this.required(false);
    }
  });
});

